export const IconChevron = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity="0.4" d="M2.66927 15.9999C2.66927 8.63612 8.63881 2.66658 16.0026 2.66658C23.3664 2.66658 29.3359 8.63612 29.3359 15.9999C29.3359 23.3637 23.3664 29.3333 16.0026 29.3333C8.63881 29.3333 2.66927 23.3637 2.66927 15.9999Z" fill="#979797"/>
      <path d="M13.3201 11.2934C13.3201 11.5467 13.4134 11.8 13.6134 12L17.6134 16L13.6134 20C13.2268 20.3867 13.2268 21.0267 13.6134 21.4134C14.0001 21.8 14.6401 21.8 15.0268 21.4134L19.7334 16.7067C20.1201 16.32 20.1201 15.68 19.7334 15.2934L15.0268 10.5867C14.6401 10.2 14.0001 10.2 13.6134 10.5867C13.4134 10.7867 13.3201 11.04 13.3201 11.2934Z" fill="#979797"/>
    </svg>
  );
};
